import { bemComponent } from '@99designs/utils/app';
export default bemComponent('panel', 'Panel');



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Panel.jsx